// 15 minutes in milliseconds
export const EMAIL_SYNC_TIMEOUT = 15 * 60 * 1000;
